<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="商品">
        <GridSelectLi
            style="width: 186px"
            title="选择商品"
            labelName="productName"
            labelValue="id"
            :value="queryForm.productId"
            :limit="1"
            size="small"
            placeholder="请选择商品"
            @getValue="getSeachValuebrandId"
            :columns="PRODUCT_code"
            :searchs="PRODUCT_search"
            dataListUrl="/shop/product/findList"
            entityBeanName="shopProduct"
            queryEntityUrl="/shop/product/get"
          >
        </GridSelectLi>
      </el-form-item>
      <el-form-item label="所属分类">
        <el-select style="width: 186px" v-model="queryForm.categoryId" placeholder="请选择" clearable size="small">
          <el-tree node-key="id" :default-expanded-keys="expands" :data="storeProductCategoryList" :props="treeProps">
            <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
              <el-option :label="node.label" :value="data.id"> </el-option>
            </div>
          </el-tree>
        </el-select>
      </el-form-item>
      <el-form-item label="门店">
        <GridSelectLi
            style="width: 186px"
            title="选择门店"
            labelName="storeName"
            labelValue="id"
            :value="queryForm.storeId"
            :limit="1"
            size="small"
            placeholder="请选择门店"
            @getValue="getSeachValuebrandId1"
            :columns="STORE_code"
            :searchs="STORE_search"
            dataListUrl="/shop/store/findList"
            entityBeanName="shopStore"
            queryEntityUrl="/shop/store/get"
          >
        </GridSelectLi>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreProductList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopStoreProduct">新建</el-button>
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editShopStoreProduct(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteShopStoreProduct(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span>
          <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span>
          <span title="导出数据" class="icon-box" @click="exportShopStoreProductList">
            <Icon color="#606266">
              <ArrowDownload24Regular />
            </Icon>
          </span>
          <span class="icon-box" @click="refreshShopStoreProductList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="shopStoreProductList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="商品" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.product">
              <div style='text-align: left'>名称：{{ scope.row.product.productName }}</div>
              <div style='text-align: left'>货号：{{ scope.row.product.productNumber }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
		<el-table-column :show-overflow-tooltip="true" align="center" prop="product.productPic" label="商品图片" width="180">
		  <template slot-scope="scope">
		    <div v-if='scope.row.product.productPic'>
		      <el-image @click='updateSrcList(scope.row.product.productPic)' style="width: 60px; height: 60px"
		        :src="scope.row.product.productPic" :preview-src-list="srcList"> </el-image>
		      </div>
		    <div v-else>--</div>
		  </template>
		</el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="价格" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.product">
              <div style='text-align: left'>商品价格：{{ scope.row.product.shopPrice }}</div>
              <div style='text-align: left'>市场价格：{{ scope.row.product.marketPrice }}</div>
              <div style='text-align: left'>供货价格：{{ scope.row.product.supplyPrice }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="category.categoryName" label="所属分类" width="180">
        </el-table-column>
        
        <el-table-column :show-overflow-tooltip="true" align="center" prop="store.storeName" label="门店名称" width="180">
        </el-table-column>
        
        <el-table-column fixed="right" align="center" label="操作" width="400">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopStoreProduct(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopStoreProduct(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopStoreProduct(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="shopStoreProductStates[shopStoreProductState]" :visible.sync="showDialog" width="60%"
        @close="closeDialog">
        <div>
          <el-form :model="shopStoreProduct" ref="shopStoreProductForm" :rules="rules" label-width="120px" :inline="true"
            size="small">
            <el-form-item label="商品" prop="productId">
              <GridSelectLi
                :disabled="shopStoreProductState == 'check'"
                style="width: 186px"
                title="选择商品"
                labelName="productName"
                labelValue="id"
                :value="shopStoreProduct.productId"
                :limit="1"
                size="small"
                placeholder="请选择商品"
                @getValue="getValuebrandId"
                :columns="PRODUCT_code"
                :searchs="PRODUCT_search"
                dataListUrl="/shop/product/findList"
                entityBeanName="shopProduct"
                queryEntityUrl="/shop/product/get"
              >
              </GridSelectLi>
            </el-form-item>
            <el-form-item label="商品分类" prop="categoryId">
              <el-select :disabled="shopStoreProductState == 'check'" style="width: 186px" v-model="shopStoreProduct.categoryId" placeholder="请选择" clearable size="small">
                <el-tree node-key="id" :default-expanded-keys="expands" :data="storeProductCategoryList" :props="treeProps">
                  <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                    <el-option :label="node.label" :value="data.id"> </el-option>
                  </div>
                </el-tree>
              </el-select>
            </el-form-item>
            <el-form-item label="门店" prop="storeId">
              <GridSelectLi
                :disabled="shopStoreProductState == 'check'"
                style="width: 186px"
                title="选择门店"
                labelName="storeName"
                labelValue="id"
                :value="shopStoreProduct.storeId"
                :limit="1"
                size="small"
                placeholder="请选择门店"
                @getValue="getValuebrandId1"
                :columns="STORE_code"
                :searchs="STORE_search"
                dataListUrl="/shop/store/findList"
                entityBeanName="shopStore"
                queryEntityUrl="/shop/store/get"
              >
              </GridSelectLi>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="shopStoreProductState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelect from '@/components/StoreManagement/SelectStore.vue';
import { PRODUCT1, PRODUCT_SEARCH1, STORE, STORE_SEARCH } from '@/utils/constant';

export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    GridSelectLi,
    // GridSelect
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetShopStoreProductList();
        this.getShopStoreProductList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetShopStoreProductList();
        this.getShopStoreProductList();
        this.$emit('resetCheckState');
      }
    }
  },
  data() {
    return {
      PRODUCT_code: PRODUCT1,
      PRODUCT_search: PRODUCT_SEARCH1,
      STORE_code: STORE,
      STORE_search: STORE_SEARCH,
      queryForm: {
        productId: '', //商品ID
        storeId: '', //门店ID
        categoryId: ''
      },
      storeProductCategoryList: [],
      treeProps: {
          children: 'children',
          label: 'categoryName'
      },
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      shopStoreProductState: 'add',
      shopStoreProductStates: {
        add: '新建商品',
        check: '查看商品',
        edit: '修改商品'
      },
      expands: [],
      multipleSelection: [],
      shopStoreProductList: [],
      shopStoreProduct: {
        productId: '', //商品ID
        storeId: '', //门店ID
        categoryId: ''
      },
      btnLoading: false,
      srcList:[""],
      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        productId: [{ required: true, message: '商品ID不能为空', trigger: 'blur' }],
        storeId: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
        categoryId:[{ required: true, message: '商品分类不能为空', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.getShopStoreProductList();
    this.getClassification();
  },
  methods: {
    // 大图预览
    updateSrcList(src) {
      this.srcList[0] = src
    },
    getClassification() {
      console.log("???")
      get(`/shop/storeproductcategory/findAllAsTree`).then((res) => {
        if (res.success && res.code == 200) {
          this.storeProductCategoryList = res.treeData;
          res.treeData.forEach((element) => {
            this.expands.push(element.id);
          });
        }
      });
    },
    // 搜索商品
    getSeachValuebrandId(value){
      this.queryForm.productId = value
    },
    // 搜索门店
    getSeachValuebrandId1(value){
      this.queryForm.storeId = value
    },
    // 选择门店
    getValuebrandId1(value) {
      this.shopStoreProduct.storeId = value;
    },
    // 选择商品
    getValuebrandId(value) {
      this.shopStoreProduct.productId = value;
    },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetShopStoreProductList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.shopStoreProductList = [];
    },
    resetDialog() {
      this.shopStoreProductState = 'add';
      this.showDialog = false;
      this.queryForm = {
        productId: '', //商品ID
        storeId: '', //门店ID
        categoryId:''
      };
      this.getShopStoreProductList();
    },
    closeDialog() {
      this.showDialog = false
      this.shopStoreProduct = {
        productId: '', //商品ID
        storeId: '', //门店ID
        categoryId:''
      };
    },
    submitForm() {
      if (this.shopStoreProductState == 'add') {
        this.$refs.shopStoreProductForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/shop/storeproduct/add`, { ...this.shopStoreProduct }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetShopStoreProductList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.shopStoreProductState == 'edit') {
        this.$refs.shopStoreProductForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            delete this.shopStoreProduct.category
            delete this.shopStoreProduct.product
            delete this.shopStoreProduct.store
            post(`/shop/storeproduct/edit`, { ...this.shopStoreProduct }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetShopStoreProductList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addShopStoreProduct() {
      this.showDialog = true;
      this.shopStoreProductState = 'add';
    },
    checkShopStoreProduct(shopStoreProductId) {
      console.log(shopStoreProductId);
      this.currentShopStoreProductId = shopStoreProductId;

      this.getShopStoreProductById();
      this.showDialog = true;
      this.shopStoreProductState = 'check';
    },
    editShopStoreProduct(shopStoreProductId) {
      console.log('shopStoreProduct', shopStoreProductId);
      if (shopStoreProductId) {
        this.currentShopStoreProductId = shopStoreProductId;
        this.getShopStoreProductById();
      } else {
        this.shopStoreProduct = { ...this.shopStoreProduct, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.shopStoreProductState = 'edit';
    },
    deleteShopStoreProduct(shopStoreProductId) {
      let ids = '';
      if (shopStoreProductId) {
        ids = shopStoreProductId;
      } else {
        ids = this.multipleSelection.map((shopStoreProduct) => shopStoreProduct.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/shop/storeproduct/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetShopStoreProductList();
              this.getShopStoreProductList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshShopStoreProductList() {
      this.resetShopStoreProductList();
      this.getShopStoreProductList();
    },
    getShopStoreProductList(query = {}) {
      this.loading = true;
      get(`/shop/storeproduct/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.shopStoreProductList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getShopStoreProductById() {
      get(`/shop/storeproduct/get`, { id: this.currentShopStoreProductId }).then((res) => {
        if (res.success) {
          this.shopStoreProduct = { ...this.shopStoreProduct, ...res.shopStoreProduct };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportShopStoreProductList() {
      //this.btnLoading = true;
      exprotExcel(`/shop/storeproduct/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/shop/storeproduct/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/shop/storeproduct/importData`, formData);
      this.refreshShopStoreProductList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getShopStoreProductList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getShopStoreProductList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>